import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { listDriverPatientDistributionsQuery } from '@services/gql.service';

export interface PatientsState extends EntityState<listDriverPatientDistributionsQuery, string> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'patients' })
export class PatientsStore extends EntityStore<PatientsState> {
  constructor() {
    super({});
  }
}
